import { CalendarToday as CalendarTodayIcon } from '@mui/icons-material';

export default function Calendar(): JSX.Element {
  return <CalendarTodayIcon fontSize="inherit" />;
}
